module.exports = __webpack_public_path__ + "static/img/bg1.837e99e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/bg1.png
// module id = +Sro
// module chunks = 1